import React, { useState } from "react";
import "../Header.css";

const Header = ({ setActivePage, activePage, setActiveTab }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => setMenuOpen(!menuOpen);

  const handleNavClick = (page, tab) => {
    setActivePage(page);
    if (tab) setActiveTab(tab); // update the tab if specified
    setMenuOpen(false); // close mobile menu after click
  };

  return (
    <header className="header">
      <div
        className="logo"
       onClick={() => handleNavClick("Video Tutorials", "video")}
        style={{ cursor: "pointer" }}
      >
        <img src="/images/LMS.png" alt="LMS Logo" />
      </div>

      {/* Hamburger icon for mobile */}
      <div className="hamburger" onClick={handleMenuToggle}>
        <span className={menuOpen ? "line1" : ""}></span>
        <span className={menuOpen ? "line2" : ""}></span>
        <span className={menuOpen ? "line3" : ""}></span>
      </div>

      {/* Navigation Menu */}
      <nav className={`nav-menu ${menuOpen ? "open" : ""}`}>
        <ul>
          <li>
            <a
              href="#"
              className={activePage === "Video Tutorials" ? "active" : ""}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("Video Tutorials", "video");
              }}
            >
              Video Tutorials
            </a>
          </li>

          <li>
            <a
              href="#"
              className={activePage === "Learning Materials" ? "active" : ""}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("Learning Materials", "pdf");
              }}
            >
              Learning Materials
            </a>
          </li>

          <li>
            <a
              href="#"
              className={activePage === "Presentation Slides" ? "active" : ""}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("Presentation Slides", "ppt");
              }}
            >
              Presentation Slides
            </a>
          </li>

           <li>
            <a
              href="#"
              className={activePage === "Worksheets" ? "active" : ""}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("Worksheets", "worksheet");
              }}
            >
              Worksheets
            </a>
          </li>
 <li>
            <a
              href="#"
              className={activePage === "Self Assessment" ? "active" : ""}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("Self Assessment", "quiz");
              }}
            >
              Self Assesmsnt
            </a>
          </li>
          <li>
            <a
              href="#"
              className={activePage === "contact" ? "active" : ""}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("contact");
              }}
            >
              Contact
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
